var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import EventContext from '../context/event-context';
import StateContext from '../context/state-context';
import { labelTransform } from './Grid';
var StyledTabButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  ", ";\n  color: ", ";\n  background-color: ", ";\n"], ["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  ", ";\n  color: ",
    ";\n  background-color: ",
    ";\n"])), function (props) { return ({ ...props.componentStyle }); }, function (_a) {
    var _b;
    var componentStyle = _a.componentStyle, fontColor = _a.fontColor;
    return (_b = fontColor !== null && fontColor !== void 0 ? fontColor : componentStyle.color) !== null && _b !== void 0 ? _b : 'inherit';
}, function (_a) {
    var _b;
    var componentStyle = _a.componentStyle, backgroundColor = _a.backgroundColor;
    return (_b = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : componentStyle.backgroundColor) !== null && _b !== void 0 ? _b : 'inherit';
});
export function Tabs(props) {
    var tabs = props.tabs, rest = __rest(props, ["tabs"]);
    var _onButtonClick = useContext(EventContext)._onButtonClick;
    var state = useContext(StateContext);
    return (React.createElement(React.Fragment, null, tabs.map(function (item, index) { return (React.createElement(StyledTabButton, __assign({ key: index }, rest, { dangerouslySetInnerHTML: labelTransform(item.label), onClick: function () { return _onButtonClick(item.id); }, fontColor: state[item.id + "_fontColor"], backgroundColor: state[item.id + "_backgroundColor"], id: item.id }))); })));
}
var templateObject_1;
//# sourceMappingURL=Tabs.js.map